import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    firstName: {
      label: {
        id: 'properties.firstName',
        defaultMessage: 'First name',
        description: 'label of the form field first name',
      },
    },
    lastName: {
      label: {
        id: 'properties.lastName',
        defaultMessage: 'Last name',
        description: 'label of the form field last name',
      },
    },
    email: {
      label: {
        id: 'properties.email',
        defaultMessage: 'E-mail',
        description: 'label of the form field e-mail',
      },
    },
  },
};

export default defineMessages(translations);
